import React from 'react';
import healthCompassLogo from '/icons/logos/health-compass.svg';

/**
 * Smooth loading overlay shown while checking inactivity status
 * Prevents flickering when returning to tab after extended time
 * @param {Object} props - Component props
 * @param {boolean} props.isVisible - Whether the overlay should be visible
 * @returns {JSX.Element|null} Loading overlay or null
 */
export default function InactivityCheckOverlay({ isVisible }) {
  if (!isVisible) return null;

  return (
    <div 
      className="fixed inset-0 bg-white z-[9999] flex items-center justify-center transition-opacity duration-200"
      style={{ opacity: isVisible ? 1 : 0 }}
    >
      <div className="flex flex-col items-center gap-4">
        {/* Logo with subtle pulse animation */}
        <img 
          src={healthCompassLogo} 
          alt="Health Compass" 
          className="h-12 w-auto animate-pulse"
        />
        
        {/* Modern spinner */}
        <div className="relative">
          <div className="w-10 h-10 border-4 border-blue-100 border-t-blue-600 rounded-full animate-spin"></div>
        </div>
        
        {/* Optional text - you can remove this if you prefer minimal design */}
        <p className="text-sm text-gray-500 mt-2">Checking session...</p>
      </div>
    </div>
  );
}

